
const validate = (input,regStr) => {

    const regex = new RegExp(regStr);
    if (regex.test(input)) return true;
    return false;
}
export const validatePass = (input) => {
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{6,}$/;
    return regex.test(input);
}
